import axios from 'axios'
import {API_ENDPOINT} from '../../config'

const all = (instance, params) => {
    instance.setState({ ...instance.state, loadingPermissions: true })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/user/permissions",
        headers: {
            "Authorization": instance.props.auth.authorization
        },
        data: params
    }).then(response => handleLoadPermissionsResponse(instance, response))
        .catch(error => {
            instance.setState({
                ...instance.state,
                loadingPermissions: false
            })
            alert(error)
        })
}

const handleLoadPermissionsResponse = (instance, response) => {
    switch (response.data.status) {
        case 200:
            instance.setState({
                ...instance.state,
                loadingPermissions: false,
                permissions: response.data.data.permissions,
                total: response.data.data.size
            })
            break;
        case 403:
            instance.props.history.push('/auth/login')
            break;
        default:
            instance.setState({
                ...instance.state,
                loadingPermissions: false
            })
            alert(response.data.message)
    }
}

const one = (instance, params) => {
    instance.setState({ ...instance.state, loadingPermission: true })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/user/permission",
        headers: {
            "Authorization": instance.props.auth.authorization
        },
        data: params
    }).then(response => handleLoadPermissionResponse(instance, response))
        .catch(error => {
            instance.setState({
                ...instance.state,
                loadingPermission: false
            })
            alert(error)
        })
}

const handleLoadPermissionResponse = (instance, response) => {
    switch (response.data.status) {
        case 200:
            instance.setState({
                ...instance.state,
                loadingPermission: false,
                permission: response.data.data.permission
            })
            break;
        case 403:
            instance.props.history.push('/auth/login')
            break;
        default:
            instance.setState({
                ...instance.state,
                loadingPermissions: false
            })
            alert(response.data.message)
    }
}

const PermissionDatasource = () => {
    return {
        all: (instance, params) => all(instance, params),
        one: (instance, params) => one(instance, params)
    }
}

export default PermissionDatasource